import React from 'react';
import { Table, Button } from 'reactstrap';
import moment from 'moment';
import Auth from '@src/components/Elements/Auth/Auth';

export default props => {
  const { entity } = props;

  return (
    <React.Fragment>
      <strong>{entity.carrier.name}</strong>
      {entity.policies.map(policy => {
        const startDate = moment(policy.start_date * 1000).format('MM/DD/YYYY');
        const endDate = moment(policy.end_date * 1000).format('MM/DD/YYYY');
        policy.carrier = entity.carrier;
        policy.carrier_id = entity.carrier_id;

        return (
          <React.Fragment key={'policy-view-' + policy.id}>
            <Table size={'sm'} borderless className={'mb-0'}>
              <tbody>
                <tr>
                  <th style={{ width: '150px' }}>Policy Number</th>
                  <td>
                    {policy.number}
                    <Auth action={'Associations::editPolicies'}>
                      {props.onDelete !== undefined && (
                        <Button
                          color={'link'}
                          className={'ml-3 px-1 py-0'}
                          onClick={() => props.onDelete(policy)}
                          style={{ lineHeight: 'initial' }}
                        >
                          Delete
                        </Button>
                      )}
                      {props.onEdit !== undefined && (
                        <Button
                          color={'link'}
                          className={'ml-3 px-1 py-0'}
                          onClick={() => props.onEdit(policy)}
                          style={{ lineHeight: 'initial' }}
                        >
                          Edit
                        </Button>
                      )}
                    </Auth>
                  </td>
                </tr>
                <tr>
                  <th>Dates</th>
                  <td>
                    {startDate} - {endDate}
                  </td>
                </tr>
              </tbody>
            </Table>
            <Table size={'sm'} borderless className={'mb-4'}>
              <thead className={'border-0'}>
                <tr>
                  <th>Coverages</th>
                  <th>Limit</th>
                  <th>Deductible</th>
                  <th style={{ width: '60%' }}>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {policy.policy_coverages.map(item => {
                  const options = [];
                  if (item.hired === 1) {
                    options.push('Hired');
                  }
                  if (item.non_owned === 1) {
                    options.push('Non-owned');
                  }
                  if (item.garage_keepers === 1) {
                    options.push('Garage keepers');
                  }
                  if (item.scheduled === 1) {
                    options.push('Scheduled');
                  }
                  if (item.claims_made === 1) {
                    options.push('Claims Made');
                  }
                  if (item.occurrence === 1) {
                    options.push('Occurrence');
                  }
                  return (
                    <tr key={`policy-coberage-${item.id}`}>
                      <td>{item.policy_type.name}</td>
                      <td>{item.maximum}</td>
                      <td>{item.deductible}</td>
                      <td>{options.join(', ')}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};
